"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * iPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.15.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoverApi = exports.RecoverApiFactory = exports.RecoverApiFp = exports.RecoverApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * RecoverApi - axios parameter creator
 * @export
 */
exports.RecoverApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Request password recovery
         * @param {InputRequestPasswordRecovery} [inputRequestPasswordRecovery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordRecovery: (inputRequestPasswordRecovery, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/recover/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inputRequestPasswordRecovery, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Reset password
         * @param {InputResetPassword} [inputResetPassword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: (inputResetPassword, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/recover/password/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inputResetPassword, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RecoverApi - functional programming interface
 * @export
 */
exports.RecoverApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.RecoverApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Request password recovery
         * @param {InputRequestPasswordRecovery} [inputRequestPasswordRecovery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordRecovery(inputRequestPasswordRecovery, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestPasswordRecovery(inputRequestPasswordRecovery, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Reset password
         * @param {InputResetPassword} [inputResetPassword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(inputResetPassword, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resetPassword(inputResetPassword, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * RecoverApi - factory interface
 * @export
 */
exports.RecoverApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.RecoverApiFp(configuration);
    return {
        /**
         *
         * @summary Request password recovery
         * @param {InputRequestPasswordRecovery} [inputRequestPasswordRecovery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordRecovery(inputRequestPasswordRecovery, options) {
            return localVarFp.requestPasswordRecovery(inputRequestPasswordRecovery, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reset password
         * @param {InputResetPassword} [inputResetPassword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(inputResetPassword, options) {
            return localVarFp.resetPassword(inputResetPassword, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RecoverApi - object-oriented interface
 * @export
 * @class RecoverApi
 * @extends {BaseAPI}
 */
class RecoverApi extends base_1.BaseAPI {
    /**
     *
     * @summary Request password recovery
     * @param {InputRequestPasswordRecovery} [inputRequestPasswordRecovery]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecoverApi
     */
    requestPasswordRecovery(inputRequestPasswordRecovery, options) {
        return exports.RecoverApiFp(this.configuration).requestPasswordRecovery(inputRequestPasswordRecovery, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reset password
     * @param {InputResetPassword} [inputResetPassword]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecoverApi
     */
    resetPassword(inputResetPassword, options) {
        return exports.RecoverApiFp(this.configuration).resetPassword(inputResetPassword, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RecoverApi = RecoverApi;
